import initialState from "./initialState";
import { SEARCH_BY_CATEGORY, SEARCH_BY_AUTHOR_NAME, SEARCH_BY_TEXT,CLEAR_FILTER } from "./actionTypes"

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCH_BY_CATEGORY:
            return {
                ...state,
                category: action.payload
            }
        case SEARCH_BY_AUTHOR_NAME:
            return {
                ...state,
                author_name: action.payload
            }
        case SEARCH_BY_TEXT:
            return {
                ...state,
                search: action.payload
            }
        case CLEAR_FILTER:
            return {
                ...state,
                category: '',
                author_name: '',
                search: ''

            }
        default:
            return state;
    }
}

export default reducer;